import { createSelector } from 'reselect';
import {
  IWorkerState,
  IWorkerCountsState,
  IWorkerCreateState,
  IWorkerInvitation,
  IWorkerDetails,
  IWorkerPreferenceUpdate,
  IWorkerStatusUpdateState,
  IMapWorkerQualificationState,
  IWorkerDocumentStatusUpdateState,
  IRateWorkerState,
  IUpdateWorkerRatingState,
  IUpdateWorkerRatesState,
  IWorkerPreferredTimingsState,
  IWorkerCustomFormSubmissionsState,
  IWorkerRoleDocumentRequirementsBulkState,
  IWorkerBulkUploadState,
} from './types';
const selectWorkerState = (state: { worker: IWorkerState }) => state.worker;
const selectWorkerCountsState = (state: { workerCounts: IWorkerCountsState }) => state.workerCounts;
const pendingWorkers = (state: { pendingWorkers: IWorkerState }) => state.pendingWorkers;
const resendInvitationState = (state: { resendInvitation: IWorkerInvitation }) => state.resendInvitation;
const selectWorkerDetailsState = (state: { workerDetails: IWorkerDetails }) => state.workerDetails;
const updateWorkerPreference = (state: { updateWorkerPreference: IWorkerPreferenceUpdate }) => state.updateWorkerPreference;
const updateWorkerDocuments = (state: { updateWorkerDocuments: IWorkerCreateState }) => state.updateWorkerDocuments;
const updateWorkerSkillAndExperience = (state: { updateWorkerSkillAndExperience: IWorkerCreateState }) => state.updateWorkerSkillAndExperience;
const markWorkerAsView = (state: { markWorkerAsView: IWorkerStatusUpdateState }) => state.markWorkerAsView;

export const selectMarkWOrkerAsViewMessage = createSelector(
  markWorkerAsView,
  (markWorkerAsView) => markWorkerAsView.message
)

export const selectMarkWorkerAsViewLoading = createSelector(
  markWorkerAsView,
  (markWorkerAsView) => markWorkerAsView.loading
)

export const selectMarkWorkerAsViewError = createSelector(
  markWorkerAsView,
  (markWorkerAsView) => markWorkerAsView.error
)

export const selectUpdateWorkerSkillAndExperienceMessage = createSelector(
  updateWorkerSkillAndExperience,
  (updateWorkerSkillAndExperience) => updateWorkerSkillAndExperience.message
)

export const selectUpdateWorkerSkillAndExperienceLoading = createSelector(
  updateWorkerSkillAndExperience,
  (updateWorkerSkillAndExperience) => updateWorkerSkillAndExperience.loading
)

export const selectUpdateWorkerSkillAndExperienceError = createSelector(
  updateWorkerSkillAndExperience,
  (updateWorkerSkillAndExperience) => updateWorkerSkillAndExperience.error
)

export const selectUpdateWorkerDocumentsMessage = createSelector(
  updateWorkerDocuments,
  (updateWorkerDocuments) => updateWorkerDocuments.message
)

export const selectUpdateWorkerDocumentsError = createSelector(
  updateWorkerDocuments,
  (updateWorkerDocuments) => updateWorkerDocuments.error
)

export const selectUpdateWorkerDocumentsLoading = createSelector(
  updateWorkerDocuments,
  (updateWorkerDocuments) => updateWorkerDocuments.loading
)

export const selectUpdatePreferenceMessage = createSelector(
  updateWorkerPreference,
  (updateWorkerPreference) => updateWorkerPreference.message
);

export const selectUpdatePreferenceError = createSelector(
  updateWorkerPreference,
  (updateWorkerPreference) => updateWorkerPreference.error
);

export const selectUpdatePreferenceLoading = createSelector(
  updateWorkerPreference,
  (updateWorkerPreference) => updateWorkerPreference.loading
);

export const selectWorkerDetails = createSelector(
  selectWorkerDetailsState,
  (workerDetailsState) => workerDetailsState.data
);

export const selectWorkerDetailsLoading = createSelector(
  selectWorkerDetailsState,
  (workerDetailsState) => workerDetailsState.loading
);

export const selectWorkerDetailsError = createSelector(
  selectWorkerDetailsState,
  (workerDetailsState) => workerDetailsState.error
);

export const selectSendInviteMessage = createSelector(
  resendInvitationState,
  (resendInvitationState) => resendInvitationState.message
)

export const selectSendInviteError = createSelector(
  resendInvitationState,
  (resendInvitationState) => resendInvitationState.error
)

export const selectSendInviteLoading = createSelector(
  resendInvitationState,
  (resendInvitationState) => resendInvitationState.loading
)

export const selectWorkerList = createSelector(
  selectWorkerState,
  (workerState) => workerState.list.results
);

export const selectWorkerListLoading = createSelector(
  selectWorkerState,
  (workerState) => workerState.loading
);

export const selectWorkerListError = createSelector(
  selectWorkerState,
  (workerState) => workerState.error
);

export const selectWorkerListCount = createSelector(
  selectWorkerState,
  (workerState) => workerState.list.count
);

export const selectPendingWorkerList = createSelector(
  pendingWorkers,
  (workerPendingState) => workerPendingState.list.results
);

export const selectPendingWorkerListLoading = createSelector(
  pendingWorkers,
  (workerPendingState) => workerPendingState.loading
);

export const selectPendingWorkerListError = createSelector(
  pendingWorkers,
  (workerPendingState) => workerPendingState.error
);

export const selectPendingWorkerListCount = createSelector(
  pendingWorkers,
  (workerPendingState) => workerPendingState.list.count
);

export const selectWorkerCount = createSelector(
  selectWorkerCountsState,
  (workerCountsState) => workerCountsState.data
);

export const selectWorkerCountsLoading = createSelector(
  selectWorkerCountsState,
  (workerCountsState) => workerCountsState.loading
);

export const selectWorkerCountsError = createSelector(
  selectWorkerCountsState,
  (workerCountsState) => workerCountsState.error
);

export const selectWorkerCreateLoading = createSelector(
  (state: { workerCreate: IWorkerCreateState }) => state.workerCreate.loading,
  (loading) => loading
);

export const selectWorkerCreateMessage = createSelector(
  (state: { workerCreate: IWorkerCreateState }) => state.workerCreate.message,
  (message) => message
);

export const selectWorkerCreateError = createSelector(
  (state: { workerCreate: IWorkerCreateState }) => state.workerCreate.error,
  (error) => error
);

const selectWorkerStatusUpdateState = (state: { workerStatusUpdate: IWorkerStatusUpdateState }) => state.workerStatusUpdate;

export const selectWorkerStatusUpdateLoading = createSelector(
  selectWorkerStatusUpdateState,
  (workerStatusUpdateState) => workerStatusUpdateState.loading
);

export const selectWorkerStatusUpdateMessage = createSelector(
  selectWorkerStatusUpdateState,
  (workerStatusUpdateState) => workerStatusUpdateState.message
);

export const selectWorkerStatusUpdateError = createSelector(
  selectWorkerStatusUpdateState,
  (workerStatusUpdateState) => workerStatusUpdateState.error
);

const selectMapWorkerQualificationState = (state: { mapWorkerQualification: IMapWorkerQualificationState }) => state.mapWorkerQualification;

export const selectMapWorkerQualificationLoading = createSelector(
  selectMapWorkerQualificationState,
  (mapWorkerQualificationState) => mapWorkerQualificationState.loading
);

export const selectMapWorkerQualificationMessage = createSelector(
  selectMapWorkerQualificationState,
  (mapWorkerQualificationState) => mapWorkerQualificationState.message
);

export const selectMapWorkerQualificationError = createSelector(
  selectMapWorkerQualificationState,
  (mapWorkerQualificationState) => mapWorkerQualificationState.error
);

const selectWorkerDocumentStatusUpdateState = (state: { workerDocumentStatusUpdate: IWorkerDocumentStatusUpdateState }) => state.workerDocumentStatusUpdate;

export const selectWorkerDocumentStatusUpdateLoading = createSelector(
  selectWorkerDocumentStatusUpdateState,
  (workerDocumentStatusUpdateState) => workerDocumentStatusUpdateState.loading
);

export const selectWorkerDocumentStatusUpdateMessage = createSelector(
  selectWorkerDocumentStatusUpdateState,
  (workerDocumentStatusUpdateState) => workerDocumentStatusUpdateState.message
);

export const selectWorkerDocumentStatusUpdateError = createSelector(
  selectWorkerDocumentStatusUpdateState,
  (workerDocumentStatusUpdateState) => workerDocumentStatusUpdateState.error
);

const selectRateWorkerState = (state: { rateWorker: IRateWorkerState }) => state.rateWorker;

export const selectRateWorkerLoading = createSelector(
  selectRateWorkerState,
  (rateWorker) => rateWorker.loading,
);

export const selectRateWorkerSuccess = createSelector(
  selectRateWorkerState,
  (rateWorker) => rateWorker.success,
);

export const selectRateWorkerError = createSelector(
  selectRateWorkerState,
  (rateWorker) => rateWorker.error,
);

export const selectRateWorkerData = createSelector(
  selectRateWorkerState,
  (rateWorker) => rateWorker.data,
);

const selectUpdateWorkerRatingState = (state: { updateWorkerRating: IUpdateWorkerRatingState }) => state.updateWorkerRating;

export const selectUpdateWorkerRatingLoading = createSelector(
  selectUpdateWorkerRatingState,
  (updateWorkerRating) => updateWorkerRating.loading,
);

export const selectUpdateWorkerRatingSuccess = createSelector(
  selectUpdateWorkerRatingState,
  (updateWorkerRating) => updateWorkerRating.success,
);

export const selectUpdateWorkerRatingError = createSelector(
  selectUpdateWorkerRatingState,
  (updateWorkerRating) => updateWorkerRating.error,
);

export const selectUpdateWorkerRatingMessage = createSelector(
  selectUpdateWorkerRatingState,
  (updateWorkerRating) => updateWorkerRating.message,
);

const selectUpdateWorkerRatesState = (state: { updateWorkerRates: IUpdateWorkerRatesState }) => state.updateWorkerRates;

export const selectUpdateWorkerRatesLoading = createSelector(
  selectUpdateWorkerRatesState,
  (updateWorkerRates) => updateWorkerRates.loading
);

export const selectUpdateWorkerRatesSuccess = createSelector(
  selectUpdateWorkerRatesState,
  (updateWorkerRates) => updateWorkerRates.success
);

export const selectUpdateWorkerRatesError = createSelector(
  selectUpdateWorkerRatesState,
  (updateWorkerRates) => updateWorkerRates.error
);

export const selectUpdateWorkerRatesData = createSelector(
  selectUpdateWorkerRatesState,
  (updateWorkerRates) => updateWorkerRates.data
);

const selectWorkerPreferredTimingsState = (state: { workerPreferredTimings: IWorkerPreferredTimingsState }) => state.workerPreferredTimings;

export const selectWorkerPreferredTimingsLoading = createSelector(
  selectWorkerPreferredTimingsState,
  (state) => state.loading
);

export const selectWorkerPreferredTimingsSuccess = createSelector(
  selectWorkerPreferredTimingsState,
  (state) => state.success
);

export const selectWorkerPreferredTimingsError = createSelector(
  selectWorkerPreferredTimingsState,
  (state) => state.error
);

export const selectWorkerPreferredTimingsData = createSelector(
  selectWorkerPreferredTimingsState,
  (state) => state.data
);

const selectWorkerCustomFormSubmissionsState = (state: { workerCustomFormSubmissions: IWorkerCustomFormSubmissionsState }) => state.workerCustomFormSubmissions;

export const selectWorkerCustomFormSubmissionsData = createSelector(
  selectWorkerCustomFormSubmissionsState,
  (state) => state.data
);

export const selectWorkerCustomFormSubmissionsLoading = createSelector(
  selectWorkerCustomFormSubmissionsState,
  (state) => state.loading
);

export const selectWorkerCustomFormSubmissionsError = createSelector(
  selectWorkerCustomFormSubmissionsState,
  (state) => state.error
);

const selectWorkerRoleDocumentRequirementsBulkState = (state: { workerRoleDocumentRequirementsBulk: IWorkerRoleDocumentRequirementsBulkState }) => state.workerRoleDocumentRequirementsBulk;

export const selectWorkerRoleDocumentRequirementsBulkData = createSelector(
  selectWorkerRoleDocumentRequirementsBulkState,
  (state) => state.data
);

export const selectWorkerRoleDocumentRequirementsBulkLoading = createSelector(
  selectWorkerRoleDocumentRequirementsBulkState,
  (state) => state.loading
);

export const selectWorkerRoleDocumentRequirementsBulkError = createSelector(
  selectWorkerRoleDocumentRequirementsBulkState,
  (state) => state.error
);
const selectWorkerBulkUploadState = (state: { workerBulkUpload: IWorkerBulkUploadState }) => state.workerBulkUpload;

export const selectWorkerBulkUploadData = createSelector(
  selectWorkerBulkUploadState,
  (state) => state.data
);

export const selectWorkerBulkUploadLoading = createSelector(
  selectWorkerBulkUploadState,
  (state) => state.loading
);

export const selectWorkerBulkUploadError = createSelector(
  selectWorkerBulkUploadState,
  (state) => state.error
);

const selectPastShiftWorkerListState = (state: { pastShiftWorkerList: IWorkerState }) => state.pastShiftWorkerList;

export const selectPastShiftWorkerList = createSelector(
  selectPastShiftWorkerListState,
  (state) => state.list.results
);

export const selectPastShiftWorkerListLoading = createSelector(
  selectPastShiftWorkerListState,
  (state) => state.loading
);

export const selectPastShiftWorkerListError = createSelector(
  selectPastShiftWorkerListState,
  (state) => state.error
);

export const selectPastShiftWorkerListCount = createSelector(
  selectPastShiftWorkerListState,
  (state) => state.list.count
);
